import { createSlice } from '@reduxjs/toolkit'
import { AppThunk, XVvsState } from 'state/types'
import fetchVvsBarAllowance, { fetchVvsBarBalance, fetchVvsBarTotalSupply } from './fetchVvsBarUser'
import { fetchVvsBoostPoolData } from './fetchVvsBoostPool'
import fetchVvsBoostAllowance, { fetchVvsBoostUserData } from './fetchVvsBoostUser'

const initialState: XVvsState = {
  userDataLoaded: false,
  barData: {
    allowance: '0',
    stakedBalance: '0',
    totalSupply: '0',
    vaults: '0',
    mine: '0',
  },
  boostData: {
    allowance: '0',
    pendingVvs: '0',
    stakes: [],
    boostedFarms: [],
  },
  boostPoolData: {
    poolWeight: '0',
    totalSupply: '0',
    poolInfo: [],
  },
}

export const fetchVvsBarPoolDataAsync = (): AppThunk => async (dispatch) => {
  const stakedBalance = await fetchVvsBarBalance()
  const totalSupply = await fetchVvsBarTotalSupply()

  const userData = {
    stakedBalance,
    totalSupply,
  }

  dispatch(updateVvsBarUserData(userData))
}

export const fetchVvsBarUserDataAsync =
  (account: string): AppThunk =>
  async (dispatch) => {
    const allowance = await fetchVvsBarAllowance(account)

    const userData = {
      allowance,
    }

    dispatch(updateVvsBarUserData(userData))
  }

export const fetchVvsBoostUserDataAsync =
  (account: string): AppThunk =>
  async (dispatch) => {
    const allowance = await fetchVvsBoostAllowance(account)
    const data = await fetchVvsBoostUserData(account)

    const [pendingVvs, stakes] = data ?? ['0', []]

    const userData = {
      allowance,
      pendingVvs,
      stakes,
    }

    dispatch(setVvsBoostUserData(userData))
  }

export const fetchVvsBoostPoolDataAsync = (): AppThunk => async (dispatch) => {
  const data = await fetchVvsBoostPoolData()
  const [totalSupply, poolWeight, ...poolInfo] = data
  const poolData = {
    totalSupply,
    poolWeight,
    poolInfo,
  }
  dispatch(setVvsBoostPoolData(poolData))
}

export const xVvsSlice = createSlice({
  name: 'xVvs',
  initialState,
  reducers: {
    setVvsBarUserData: (state, action) => {
      const userBarData = action.payload
      state.barData = userBarData
      state.userDataLoaded = true
    },
    updateVvsBarUserData: (state, action) => {
      const value = action.payload
      state.barData = { ...state.barData, ...value }
    },
    setVvsBoostUserData: (state, action) => {
      const userBoostData = action.payload
      state.boostData = userBoostData
      state.userDataLoaded = true
    },
    updateVvsBoostUserData: (state, action) => {
      const { field, value } = action.payload
      state.boostData = { ...state.boostData, [field]: value }
    },
    setVvsBoostPoolData: (state, action) => {
      const data = action.payload
      state.boostPoolData = data
    },
  },
})

// Actions
export const {
  updateVvsBarUserData,
  setVvsBarUserData,
  updateVvsBoostUserData,
  setVvsBoostUserData,
  setVvsBoostPoolData,
} = xVvsSlice.actions

export default xVvsSlice.reducer
